import { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { CommonApiData } from '../CommonComponents/EnvConfig';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, readFile } from '../CommonComponents/ExportData';
import { AutoCompleteBoxNew, ImportButton } from "../CommonComponents/InputBox";


const UploadCandidateData = () => {
    const dispatch = useDispatch();
    const [Name, setName] = useState('');
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [formData, setFormData] = useState({
        event: '',
        client: ''
    });
    const inputrefs = useRef([]);

    const handleClear = () => {
        setFormData({
            event: '',
            client: ''
        })
        setImportData([])
        setStatus([])
        setName('')
    }

    const DownloadFormat = async () => {
        await DownloadFileAtURL('CandidateDetails.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'CandidateDetailsError')
    }

    const handleBulk = async () => {
        if (formData.client === '') {
            NotificationSound('ERROR', 'Please Enter Client.!', 'txtClient', inputrefs)
            return;
        }
        else if (formData.event === '') {
            NotificationSound('ERROR', 'Please Enter Event.!', 'txtEvent', inputrefs)
            return;
        }
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "Client": formData.client || '',
            "Event": formData.event || ''

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("RollNo", "MobileNo", "EmailID")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateCandidateMaster', ImportData, Data2, () => { })
                console.log(Data, 'DataDataDataData')
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    useEffect(() => {
        document.title = 'Upload Candidate Data';
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Upload Candidate Data'} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className="row">
                            <div className='col-md-4'>
                                <AutoCompleteBoxNew
                                    id="txtClient"
                                    divclassname='col-md-9 mb-1'
                                    label='Client'
                                    required={true}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtEvent'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    maxLength='50'
                                    placeholder='Client'
                                    name='ClientCode'
                                    value={formData.client || ''}
                                    onChange={(e) => setFormData({ ...formData, client: e.target.value })}
                                    autocompleteType='GetClientData'
                                />
                                <AutoCompleteBoxNew
                                    id="txtEvent"
                                    divclassname='col-md-9 mb-1'
                                    required={true}
                                    label='Event'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    maxLength='50'
                                    placeholder='Event'
                                    name='EventCode'
                                    value={formData.event || ''}
                                    autocompleteType='GetEventData'
                                    contextKey={formData.client}
                                    onChange={async (event, newInputValue) => {
                                        newInputValue = newInputValue || ''
                                        if (event.type !== 'keydown') {
                                            setFormData({ ...formData, event: newInputValue })
                                        }
                                    }}
                                />
                            </div>
                            <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                                <ImportButton
                                    handleBulk={handleBulk}
                                    BulkSubmit={(e) => BulkSubmit(e)}
                                    downloadFormat={DownloadFormat}
                                    ErrorData={ErrorData}
                                    Status={Status}
                                    fileName={Name}
                                >
                                </ImportButton>
                            </div>
                            <div className='d-block d-md-flex' >
                                <div className="mb-3">
                                    <button type="button" className="btn btn-rounded btn-success me-2 mb-0" onClick={handleBulk}>
                                        <i className="fa fa-upload text-white color-success"></i> Upload
                                    </button>
                                    <button type="button" className="btn btn-rounded btn-danger me-2 mb-0" onClick={handleClear}>
                                        <i className="fa fa-remove text-white color-danger"></i> Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default UploadCandidateData;